import getConfig from '../config';

const config = getConfig();

export default {
  firebaseConfig: {
    apiKey: config.firebaseApiKey,
    authDomain: `${config.firebaseProjectId}.firebaseapp.com`,
    databaseURL: `https://${config.firebaseProjectId}.firebaseio.com`,
    projectId: config.firebaseProjectId,
    storageBucket: `${config.firebaseProjectId}.appspot.com`,
    messagingSenderId: config.firebaseMessagingSenderId,
  }
}



// WEBPACK FOOTER //
// ./src/constants/Firebase.js